
                export default function (Component) {
                    Component.__source = "library/components/VabAvatar/index.vue"
                }
            